import React from "react";
import AppConfig from "util/AppConfig";
import { Alert } from "components/bootstrap";
import { Link } from "components/common";
import Routes from "routing/Routes";
import useForwardersConfiguration from "forwarder/wizard/select-forwarder-step/hooks/useForwardersConfiguration";
const ForwarderInputInformation = ({ forwarderInputs = [] }) => {
  const { data, isLoading } = useForwardersConfiguration();
  if (AppConfig.isCloud() || (data == null ? void 0 : data.forwarder_service_autostart) || isLoading) {
    return null;
  }
  if (forwarderInputs.length === 0) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, "No Forwarder Input found, please create one on the ", /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.INPUTS }, "Inputs page"), " and try again.");
  }
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "Using Input ", /* @__PURE__ */ React.createElement("em", null, forwarderInputs[0].title), " to provide configuration options.");
};
export default ForwarderInputInformation;
